import { TransactionType } from './transaction-type';

export class TbaEvaluationMethod {
  tbaEvaluationMethodId: number;
  name: string;
  transactionTypes: TransactionType[];
}
